/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PortfolioItemConstants from '@sell/const/PortfolioItem';
import { track as trackAction, Events } from '@app/analytics';
import { AddPortfolioIcon } from '@stockx/icons';
import { Button, IconButton } from '@stockx/ui';
import { useInitiateUserLogin, useUserIsLoggedIn } from '@app/user';
import { AddPortfolioItemCTAProps } from './AddPortfolioItemCTAProps';

const AddPortfolioItemCTA: React.FC<AddPortfolioItemCTAProps> = ({
  action = PortfolioItemConstants.actions.HOLD,
  icon,
  text,
  product,
  setIsModalOpen,
}) => {
  const { t } = useTranslation();
  const isLoggedIn = useUserIsLoggedIn();
  const initiateUserLogin = useInitiateUserLogin();

  const dispatch = useDispatch();

  const track = useCallback(
    (payload) => dispatch(trackAction(payload)),
    [dispatch],
  );

  const handleAuth0 = useCallback(() => {
    initiateUserLogin();
  }, [initiateUserLogin]);

  const handleClick = useCallback(
    (action, e) => {
      e.preventDefault();
      if (!isLoggedIn) {
        handleAuth0();
      }

      setIsModalOpen(true);

      let properties = {};
      if (product) {
        properties = {
          category: product.productCategory,
          label: product.title,
        };
      }

      if (action === PortfolioItemConstants.actions.HOLD) {
        track({ event: Events.CollectionAddSneaker, properties });
      } else if (action === PortfolioItemConstants.actions.WANT) {
        track({ event: Events.FollowAddSneaker, properties });
      }
    },
    [isLoggedIn, setIsModalOpen, product, handleAuth0, track],
  );

  return icon ? (
    // Used only on calendar item / new releases
    <IconButton
      size="lg"
      mt={-3}
      mr={-1.5}
      icon={<AddPortfolioIcon boxSize={7} />}
      onClick={isLoggedIn ? (e) => handleClick(action, e) : () => handleAuth0()}
      aria-label={t('follow_item_or_add_to_portfolio', {
        title: product?.title,
      })}
      aria-haspopup="true"
    />
  ) : (
    <Button
      onClick={isLoggedIn ? (e) => handleClick(action, e) : () => handleAuth0()}
      variant="primary"
      aria-label={t('follow_item_or_add_to_portfolio', {
        title: product?.title,
      })}
      aria-haspopup="true"
    >
      {text}
    </Button>
  );
};

export default AddPortfolioItemCTA;
